import React, { useEffect } from "react";

import GreyTable from "../../../../components/Tables/GreyTable";
import { Col, Row, Container } from "react-bootstrap";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { MasterWise, resetMasterWise } from "../../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import Chart from "../../../../components/Charts/Chart";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";


export default function GroupWise({ selectedProduction, selectedAccount }) {

  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { MasterWisedata } = useSelector((state) => state.GreyDashboardSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  useEffect(() => {
    dispatch(resetMasterWise())
    dispatch(MasterWise({
      groupIDs: selectedProduction.join(","),
      partyIDs: selectedAccount.join(",")
    }))
  }, [selectedProduction, selectedAccount])


  const formatFinancialYearFromRange = (range) => {
    if (!range) return "";

    // split "1/04/2024 - 31/03/2025"
    const parts = range.split("-");

    if (parts.length === 2) {
      const startPart = parts[0].trim(); // "1/04/2024"
      const endPart = parts[1].trim();   // "31/03/2025"

      const startYear = startPart.split("/").pop(); // 2024
      const endYear = endPart.split("/").pop().slice(-2); // 25

      return `${startYear}-${endYear}`;
    }

    return "";
  };

  const yearLabel = formatFinancialYearFromRange(
    MasterWisedata?.BalMeter?.[0]?.FAcYear
  );

  const tableData = (MasterWisedata?.BalMeter || []).map(
    (row, index, arr) => ({
      // srNumber: (index + 1),
      ProductionGroupMstName: row.ProductionGroupMstName,
      BalMeter: row.BalMeter,
    })
  );

  const columns = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Production Name",
      key: "ProductionGroupMstName",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: `Meter (${yearLabel})`,
      key: "BalMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
  ];


  const tableData1 = (MasterWisedata?.BalMeter || []).map((item, index) => ({
    // srNumber: index + 1,
    ProductionGroupMstName: item.ProductionGroupMstName,

    BalApril: item.BalApril,
    BalMay: item.BalMay,
    BalJun: item.BalJun,
    BalJuly: item.BalJuly,
    BalAugust: item.BalAugust,
    BalSeptember: item.BalSeptember,
    BalOctober: item.BalOctober,
    BalNovember: item.BalNovember,
    BalDecember: item.BalDecember,
    BalJanuary: item.BalJanuary,
    BalFebruary: item.BalFebruary,
    BalMarch: item.BalMarch,

    BalMeter: item.BalMeter,
  }));
  const columns1 = [
    { label: "Charts", key: "charts" },
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },
    {
      label: "Production Name",
      key: "ProductionGroupMstName",
      align: "left",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },

    {
      label: "Total Meter",
      key: "BalMeter",
      align: "right",
      format: true,
      colors:
        isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour5,
    },
    { label: "Apr", key: "BalApril", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "May", key: "BalMay", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Jun", key: "BalJun", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Jul", key: "BalJuly", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Aug", key: "BalAugust", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Sep", key: "BalSeptember", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Oct", key: "BalOctober", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Nov", key: "BalNovember", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Dec", key: "BalDecember", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Jan", key: "BalJanuary", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Feb", key: "BalFebruary", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
    { label: "Mar", key: "BalMarch", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, },
  ];

  const chartData1 = (MasterWisedata?.BalMeter || []).map((row) => ({
    month: row.ProductionGroupMstName,
    value: row.BalMeter
  }));


  const isNoData =
    !MasterWisedata?.BalMeter || MasterWisedata.BalMeter.length === 0

  if (MasterWisedata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }


  return (
    <Container fluid style={{ padding: 0, margin: 0 }}>
      <Row
        className="justify-content-center"
        style={{ margin: 0, padding: 0 }}
      >

        <Col xl={12} className=' p-0'>
          <div>
            <Chart data={chartData1} title="Groupwise Balance Meter" />
          </div>
        </Col>
        <Col xl={12} style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                className="text-xl font-semibold tracking-wide"
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "700"
                }}
              >
                GROUPWISE DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"
              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns} data={tableData} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>

        <Col xl={12} className="pt-4" style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                className="text-xl font-semibold tracking-wide"
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "700"

                }}
              >
                MONTHWISE DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"
              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns1} data={tableData1} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>

      </Row>
    </Container>
  );
}